import { default as IconRecordAccount } from './account-record.svg';
import { default as IconAddUser } from './add-user.svg';
import { default as IconArrowBack } from './arrow-back.svg';
import { default as IconArrowDownLarge } from './arrow-down-large.svg';
import { default as IconArrowDown } from './arrow-down.svg';
import { default as IconArrowDownFill } from './arrow-down-fill.svg';
import { default as IconArrowLeft } from './arrow-left.svg';
import { default as IconArrowRight } from './arrow-right.svg';
import { default as IconArrowUpLarge } from './arrow-up-large.svg';
import { default as IconArrowUp } from './arrow-up.svg';
import { default as IconBell } from './bell.svg';
import { default as IconBluetooth } from './bluetooth.svg';
import { default as IconCalendar } from './calendar.svg';
import { default as IconCameraRefresh } from './camera-refresh.svg';
import { default as IconCar } from './car.svg';
import { default as IconChatUnread } from './chat-unread.svg';
import { default as IconCheck } from './check.svg';
import { default as IconClose } from './close.svg';
import { default as IconCloseCircle } from './close-circle.svg';
import { default as IconCloseLarge } from './close-large.svg';
import { default as IconCloudUpload } from './cloud-upload.svg';
import { default as IconCode } from './code.svg';
import { default as IconConnection } from './connection.svg';
import { default as IconRecordContact } from './contact-record.svg';
import { default as IconCopy } from './copy.svg';
import { default as IconCopyLink } from './copy-link.svg';
import { default as IconDotsHorizontal } from './dots-horizontal.svg';
import { default as IconDotsHorizontalFill } from './dots-horizontal-fill.svg';
import { default as IconDownload } from './download.svg';
import { default as IconE2EE } from './e2ee.svg';
import { default as IconEdit } from './edit.svg';
import { default as IconEmotionsAngry } from './emotions-angry.svg';
import { default as IconEmotionsDisgusted } from './emotions-disgusted.svg';
import { default as IconEmotionsFearful } from './emotions-fearful.svg';
import { default as IconEmotionsHappy } from './emotions-happy.svg';
import { default as IconEmotionsNeutral } from './emotions-neutral.svg';
import { default as IconEmotionsSad } from './emotions-sad.svg';
import { default as IconEmotionsSurprised } from './emotions-surprised.svg';
import { default as IconEnlarge } from './enlarge.svg';
import { default as IconEnterFullscreen } from './enter-fullscreen.svg';
import { default as IconEnvelope } from './envelope.svg';
import { default as IconExclamationSolid } from './exclamation-solid.svg';
import { default as IconExclamationTriangle } from './exclamation-triangle.svg';
import { default as IconExitFullscreen } from './exit-fullscreen.svg';
import { default as IconFaceSmile } from './face-smile.svg';
import { default as IconFavoriteSolid } from './favorite-solid.svg';
import { default as IconFavorite } from './favorite.svg';
import { default as IconFeedback } from './feedback.svg';
import { default as IconGear } from './gear.svg';
import { default as IconGoogle } from './google.svg';
import { default as IconHangup } from './hangup.svg';
import { default as IconDeviceHeadphone } from './headset.svg';
import { default as IconHelp } from './help.svg';
import { default as IconHighlight } from './highlight.svg';
import { default as IconRingGroup } from './icon-ring-group.svg';
import { default as IconImage } from './image.svg';
import { default as IconInfoCircle } from './info-circle.svg';
import { default as IconInfo } from './info.svg';
import { default as IconInfoRoom } from './info-room.svg';
import { default as IconRecordLead } from './lead-record.svg';
import { default as IconMessage } from './message.svg';
import { default as IconMessageFill } from './message-fill.svg';
import { default as IconMeter } from './meter.svg';
import { default as IconMicSlash } from './mic-slash.svg';
import { default as IconMicSlashIncaditor } from './mic-slash-incaditor.svg';
import { default as IconMic } from './mic.svg';
import { default as IconMicFill } from './mic-fill.svg';
import { default as IconMicBan } from './mic-ban.svg';
import { default as IconModerator } from './moderator.svg';
import { default as IconConnectionInactive } from './ninja.svg';
import { default as IconNoiseSuppressionOff } from './noise-suppression-off.svg';
import { default as IconNoiseSuppressionOn } from './noise-suppression-on.svg';
import { default as IconOffice365 } from './office365.svg';
import { default as IconRecordOpportunity } from './opportunity-record.svg';
import { default as IconPerformance } from './performance.svg';
import { default as IconPhoneRinging } from './phone-ringing.svg';
import { default as IconPin } from './pin.svg';
import { default as IconPinned } from './pinned.svg';
import { default as IconPlay } from './play.svg';
import { default as IconPlus } from './plus.svg';
import { default as IconPlusPrimary } from './plus-primary.svg';
import { default as IconMinusPrimary } from './minus-primary.svg';
import { default as IconRaiseHand } from './raise-hand.svg';
import { default as IconRaiseHandFill } from './raise-hand-fill.svg';
import { default as IconRecord } from './record.svg';
import { default as IconRecordHeader } from './record-header.svg';
import { default as IconReply } from './reply.svg';
import { default as IconRestore } from './restore.svg';
import { default as IconScreenshare } from './screenshare.svg';
import { default as IconScreenshareFill } from './screenshare-fill.svg';
import { default as IconSearch } from './search.svg';
import { default as IconSecurityOff } from './security-off.svg';
import { default as IconSecurityOn } from './security-on.svg';
import { default as IconSecurityFill } from './security-fill.svg';
import { default as IconSend } from './send.svg';
import { default as IconShareDoc } from './share-doc.svg';
import { default as IconShare } from './share.svg';
import { default as IconShortcuts } from './shortcuts.svg';
import { default as IconSip } from './sip.svg';
import { default as IconSites } from './sites.svg';
import { default as IconRemoteControlStart } from './start-remote-control.svg';
import { default as IconRemoteControlStop } from './stop-remote-control.svg';
import { default as IconStop } from './stop.svg';
import { default as IconSubtitles } from './subtitles.svg';
import { default as IconSubtitlesFill } from './subtitles-fill.svg';
import { default as IconTileView } from './tile-view.svg';
import { default as IconTrash } from './trash.svg';
import { default as IconUserDeleted } from './user-deleted.svg';
import { default as IconUser } from './user.svg';
import { default as IconUsers } from './users.svg';
import { default as IconUsersFill } from './users-fill.svg';
import { default as IconLobbyUser } from './lobby-user.svg';
import { default as IconLobbyUsers } from './lobby-users.svg';
import { default as IconVideoOff } from './video-off.svg';
import { default as IconVideoOffIncaditor } from './video-off-incaditor.svg';
import { default as IconVideo } from './video.svg';
import { default as IconVideoFill } from './video-fill.svg';
import { default as IconVideoBan } from './video-ban.svg';
import { default as IconAudioOnlyOff } from './visibility-off.svg';
import { default as IconAudioOnly } from './visibility.svg';
import { default as IconVolumeOff } from './volume-off.svg';
import { default as IconVolumeUp } from './volume-up.svg';
import { default as IconWarningCircle } from './warning-circle.svg';
import { default as IconWarningCircleFill } from './warning-circle-fill.svg';
import { default as IconWarning } from './warning.svg';
import { default as IconWhiteboardHide } from './whiteboard-hide.svg';
import { default as IconWhiteboard } from './whiteboard.svg';
import { default as IconWifi1Bar } from './wifi-1.svg';
import { default as IconWifi2Bars } from './wifi-2.svg';
import { default as IconWifi3Bars } from './wifi-3.svg';
import { default as IconYahoo } from './yahoo.svg';
import { default as LogoColor } from '../../../../../images/logo-color.svg';
import { default as IconLobbyAccept } from './lobby-accept.svg';
import { default as IconLobbyReject } from './lobby-reject.svg';
import { default as IconCascadeRoom } from './cascade-room.svg';
// Menu controller
import { default as IconUnpin } from "./icon-unpin.svg";
import { default as IconPinCC } from "./icon-pin.svg";
import { default as IconSharing } from "./icon-sharing.svg";
// Textfield
import { default as IconClear } from "./clear-input.svg";
import { default as IconEyeShow } from "./eye-show.svg";
import { default as IconEyeHide } from "./eye-hide.svg";
// Layout
import { default as IconLayoutTile } from "./layout-tileview.svg";
import { default as IconLayoutTile2 } from "./layout-tileview-2.svg";
import { default as IconLayoutSpeaker } from "./layout-speakerview.svg";
import { default as IconTypeFocus } from "./icon-type-focus.svg";
import { default as IconError } from "./error.svg";
import { default as IconSuccess } from "./success.svg";
import { default as IconLoading } from "./loading.svg";
import { default as IconRefresh } from "./refresh.svg";
import { default as IconFullScreen } from "./full-screen.svg";
import { default as IconAttach } from "./attach.svg";
import { default as IconPowerpointAttach } from "./pp-attach.svg";
import { default as IconWordAttach } from "./w-attach.svg";
import { default as IconExcelAttach } from "./x-attach.svg";
import { default as IconFileAttach } from "./file-attach.svg";
import { default as IconTextAttach } from "./text-attach.svg";
import { default as IconZipAttach } from "./zip-attach.svg";
import { default as IconPdfAttach } from "./pdf-attach.svg";
import { default as IconAttachment } from "./attachment.svg";
import { default as IconSendMessage } from "./send-message.svg";
import { default as IconArrowDownSmall } from "./arrow-down-small.svg";
import { default as IconArrowDownWide } from "./icon-arrow-down-wide.svg";
import { default as IconSmileSticker } from "./smile-sticker.svg";
import { default as IconInfoToast } from "./info-toast.svg";
import { default as IconWarningToast } from "./warning-toast.svg";
import { default as IconErrorToast } from "./error-toast.svg";
import { default as IconZoomIn } from "./zoom-in.svg";
import { default as IconZoomOut } from "./zoom-out.svg";
// Icon thumbnail
import { default as IconVerified } from "./verified.svg";
import { default as IconCrown } from "./crown.svg";
import { default as IconKeyGold } from "./key-gold.svg";
import { default as IconKeySilver } from "./key-silver.svg";
// Icon pin/unpin label
import { default as IconPinLabel } from "./pin-label.svg";
import { default as IconUnpinLabel } from "./unpin-label.svg";
import { default as IconSIPConnect } from "./sip-connect.svg";
// Icon stats
import { default as IconLineArrowUp } from "./line-arrow-up.svg";
import { default as IconLineArrowDown } from "./line-arrow-down.svg";
// Polls
import { default as EmptyPolls } from "./empty-polls.svg";
import { default as IconEditPolls } from './editIcon.svg';
import { default as IconDeletePolls } from './deleteIcon.svg';
import { default as IconVoted } from './voted-icon.svg';
import { default as IconClockCountDown } from './icon-clock-count-down.svg';
import { default as IconClock } from './icon-clock.svg';
// Icon Save caption
import { default as IconSaveCaption } from "./save-caption.svg";
import { default as IconForward } from "./forward.svg";
import { default as IconExpandArrow } from "./expand-arrow.svg";
/**
 * Map containing the default icons.
 */
export const DEFAULT_ICON = {
    IconAddUser,
    IconArrowBack,
    IconArrowDown,
    IconArrowDownFill,
    IconArrowDownLarge,
    IconArrowLeft,
    IconArrowUp,
    IconArrowUpLarge,
    IconAudioOnly,
    IconAudioOnlyOff,
    IconBluetooth,
    IconBell,
    IconCalendar,
    IconCameraRefresh,
    IconCascadeRoom,
    IconCar,
    IconChatUnread,
    IconCheck,
    IconClose,
    IconCloseCircle,
    IconCloseLarge,
    IconCloudUpload,
    IconCode,
    IconConnection,
    IconConnectionInactive,
    IconCopy,
    IconCopyLink,
    IconDeviceHeadphone,
    IconDotsHorizontal,
    IconDotsHorizontalFill,
    IconDownload,
    IconE2EE,
    IconEdit,
    IconEnlarge,
    IconEnterFullscreen,
    IconEnvelope,
    IconEmotionsAngry,
    IconEmotionsDisgusted,
    IconEmotionsFearful,
    IconEmotionsHappy,
    IconEmotionsNeutral,
    IconEmotionsSad,
    IconEmotionsSurprised,
    IconExclamationSolid,
    IconExclamationTriangle,
    IconExitFullscreen,
    IconFaceSmile,
    IconFavorite,
    IconFavoriteSolid,
    IconFeedback,
    IconGear,
    IconGoogle,
    IconHangup,
    IconHelp,
    IconHighlight,
    IconImage,
    IconInfo,
    IconInfoRoom,
    IconInfoCircle,
    IconMessage,
    IconMessageFill,
    IconMeter,
    IconMic,
    IconMicFill,
    IconMicBan,
    IconMicSlash,
    IconModerator,
    IconNoiseSuppressionOff,
    IconNoiseSuppressionOn,
    IconArrowRight,
    IconOffice365,
    IconPerformance,
    IconPhoneRinging,
    IconPin,
    IconPinned,
    IconPlay,
    IconPlus,
    IconPlusPrimary,
    IconMinusPrimary,
    IconRaiseHand,
    IconRaiseHandFill,
    IconRecord,
    IconRecordHeader,
    IconRecordAccount,
    IconRecordContact,
    IconRecordLead,
    IconRecordOpportunity,
    IconRemoteControlStart,
    IconRemoteControlStop,
    IconReply,
    IconRestore,
    IconRingGroup,
    IconScreenshare,
    IconScreenshareFill,
    IconSearch,
    IconSecurityOff,
    IconSecurityOn,
    IconSecurityFill,
    IconSend,
    IconShare,
    IconShareDoc,
    IconShortcuts,
    IconSip,
    IconSites,
    IconStop,
    IconSubtitles,
    IconSubtitlesFill,
    IconTileView,
    IconTrash,
    IconUserDeleted,
    IconUsers,
    IconUsersFill,
    IconUser,
    IconVideo,
    IconVideoFill,
    IconVideoBan,
    IconVideoOff,
    IconVolumeOff,
    IconVolumeUp,
    IconWarning,
    IconWarningCircle,
    IconWarningCircleFill,
    IconWhiteboard,
    IconWhiteboardHide,
    IconWifi1Bar,
    IconWifi2Bars,
    IconWifi3Bars,
    IconYahoo,
    LogoColor,
    IconUnpin,
    IconPinCC,
    IconSharing,
    IconLobbyAccept,
    IconLobbyReject,
    IconMicSlashIncaditor,
    IconVideoOffIncaditor,
    IconClear,
    IconEyeShow,
    IconEyeHide,
    IconLayoutTile,
    IconLayoutTile2,
    IconLayoutSpeaker,
    IconTypeFocus,
    IconError,
    IconSuccess,
    IconLoading,
    IconRefresh,
    IconAttach,
    IconPowerpointAttach,
    IconWordAttach,
    IconExcelAttach,
    IconFileAttach,
    IconTextAttach,
    IconZipAttach,
    IconPdfAttach,
    IconAttachment,
    IconSendMessage,
    IconArrowDownSmall,
    IconArrowDownWide,
    IconSmileSticker,
    IconInfoToast,
    IconWarningToast,
    IconErrorToast,
    IconZoomIn,
    IconZoomOut,
    IconVerified,
    IconCrown,
    IconKeyGold,
    IconKeySilver,
    IconFullScreen,
    IconLobbyUser,
    IconLobbyUsers,
    IconPinLabel,
    IconUnpinLabel,
    IconLineArrowUp,
    IconLineArrowDown,
    IconSIPConnect,
    EmptyPolls,
    IconEditPolls,
    IconDeletePolls,
    IconVoted,
    IconClockCountDown,
    IconClock,
    IconSaveCaption,
    IconForward,
    IconExpandArrow
};
